/**
 * ForgotPassword.js
 * Password reset request component
 */

import React, { useState } from 'react';
import { Card, Form, Button, Alert, Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { authService } from '../../services/api';
import './Login.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      setError('Email obbligatoria');
      return;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError('Inserisci un indirizzo email valido');
      return;
    }

    try {
      setLoading(true);
      setError('');
      setSuccess(false);
      
      const response = await authService.requestPasswordReset(email);
      
      if (response.success) {
        setSuccess(true);
        setEmail('');
      } else {
        setError(response.message || 'Errore nella richiesta di reset password');
      }
    } catch (err) {
      setError('Errore di connessione al server');
      console.error('Password reset request error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container fluid className="login-container">
      <Row className="justify-content-center align-items-center min-vh-100">
        <Col xs={12} sm={11} md={10} lg={8} xl={6} xxl={5}>
          <Card className="login-card">
            <div className="login-header">
              <h3 className="mb-0">
                <i className="fas fa-key me-2"></i>
                Recupero Password
              </h3>
              <p className="mb-0 mt-2">Inserisci la tua email per reimpostare la password</p>
            </div>
            
            <Card.Body className="login-body">
              {error && (
                <Alert variant="danger" className="mb-3">
                  {error}
                </Alert>
              )}

              {success && (
                <Alert variant="success" className="mb-3">
                  <strong>Email inviata!</strong><br />
                  Se l'indirizzo email esiste nel nostro sistema, riceverai le istruzioni per reimpostare la password.
                  Controlla anche la cartella spam.
                </Alert>
              )}
              
              {!success && (
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-4">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="Inserisci la tua email"
                      disabled={loading}
                      required
                    />
                    <Form.Text className="text-muted">
                      Ti invieremo un link per reimpostare la password
                    </Form.Text>
                  </Form.Group>
                  
                  <Button
                    type="submit"
                    variant="primary"
                    size="lg"
                    className="w-100 mb-3"
                    disabled={loading}
                  >
                    {loading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Invio in corso...
                      </>
                    ) : (
                      <>
                        <i className="fas fa-paper-plane me-2"></i>
                        Invia link di reset
                      </>
                    )}
                  </Button>
                </Form>
              )}

              <div className="text-center">
                <Link to="/login" className="text-decoration-none">
                  <i className="fas fa-arrow-left me-2"></i>
                  Torna al login
                </Link>
              </div>
              
              <div className="text-center mt-4">
                <small className="text-muted">
                  © 2025 Fitmanager - Sistema di gestione per associazioni sportive
                </small>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ForgotPassword;
